import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class KuposButton extends Component {
  static propTypes = {
    disabled:PropTypes.bool,
    onClick:PropTypes.func,
    className:PropTypes.string
  };

  render() {
    return (
      <button className={"kupos-button " + this.props.className} disabled={this.props.disabled} onClick={this.props.onClick}><span>{this.props.children}</span> </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/KuposButton.js